module.exports = __webpack_public_path__ + "img/45-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO5.a99dd488.jpg";